import wix from '../services/wix';
import { chatSdk } from '@wix/chat-sdk';
import { WIX_CODE_CHATROOM_TYPE } from '@wix/wix-chat-transform-bo-events/dist/lib/constants-wixCode';

export const getChannel = ({
  type,
  channelId = '',
  requestId,
}: {
  type: string;
  channelId?: string;
  requestId: string;
}) => {
  return async function(dispatch, getState) {
    const responseEventName = `ChatWidget.getChannelResponse.${requestId}`;

    try {
      const { currentChatroom, businessChatRoomId = '' } = getState();

      let idToRequestFromSdk = channelId;
      if (!channelId) {
        const isCurrentChatroomBusiness =
          currentChatroom && currentChatroom.id === businessChatRoomId;
        switch (type) {
          case WIX_CODE_CHATROOM_TYPE.BUSINESS:
            if (!businessChatRoomId) {
              break;
            }
            idToRequestFromSdk = businessChatRoomId;
            break;
          case WIX_CODE_CHATROOM_TYPE.FOCUSED:
            if (!currentChatroom && !businessChatRoomId) {
              break;
            }
            idToRequestFromSdk =
              isCurrentChatroomBusiness ||
              (!currentChatroom && businessChatRoomId)
                ? businessChatRoomId
                : currentChatroom.id;
            break;
          default:
            return wix.publishToPubSub(responseEventName, { success: false });
        }
      }

      if (!idToRequestFromSdk) {
        return wix.publishToPubSub(responseEventName, { success: false });
      }

      const room = await chatSdk.getChatroom({
        chatroomId: idToRequestFromSdk,
      });
      wix.publishToPubSub(responseEventName, {
        success: true,
        results: {
          channel: room,
          type:
            businessChatRoomId && idToRequestFromSdk === businessChatRoomId
              ? WIX_CODE_CHATROOM_TYPE.BUSINESS
              : WIX_CODE_CHATROOM_TYPE.SOCIAL,
        },
      });
    } catch (e) {
      console.error('Catch an error in getChannel Action,', e);
      wix.publishToPubSub(responseEventName, { success: false });
    }
  };
};
